import { ImageWithFocalPoint as ImageWithFocalPointProps } from '@silvertours/common-landingpages-view';
import { StyledImage } from './ImageWithFocalPoint.style';

export const ImageWithFocalPoint = ({
  className,
  src,
  alt,
  width,
  height,
  focalPoint,
}: ImageWithFocalPointProps & { className?: string }) => {
  const xPercentage =
    focalPoint && width ? (focalPoint.x * 100) / width : undefined;
  const yPercentage =
    focalPoint && height ? (focalPoint.y * 100) / height : undefined;
  return (
    <StyledImage
      className={className}
      src={src}
      alt={alt}
      fill
      x={xPercentage}
      y={yPercentage}
    />
  );
};
